

<div *ngIf="frecuencyZonesMapSectionService.isVisible |async" class="frecuency-zones-container">
    <loading [isLoading]="isLoading"></loading>
    <div class="side-panel">
        <div class="panel-header">
            <div class="header-actions">
                <button class="header-action-btn" title="Cerrar" (click)="frecuencyZonesMapSectionService.closePanel()">
                    <img class="button-icon" [src]="'cancelar.svg' | findUrl" alt="Cerrar">
                </button>
            </div>
            <h2 class="panel-title">Frecuencia de ruta</h2>
        </div>

        <div class="panel-content">
            
            <div class="search-section">
                <p *ngIf="!isMapSelectionActive" class="section-label">Búsqueda de ubicación</p>
                <label *ngIf="isMapSelectionActive" class="section-label">Selecciona un punto en mapa</label>
                <label *ngIf="isMapSelectionActive" class="section-label" style="font-size: 0.5vw;">o desactiva el botón de la derecha para buscar una dirección</label>
                
                <div class="geocoder-container" [class.directions-space]="isDropdownVisible">
                    <geocoder #frecuencyGeocoder
                        [layerSuffix]="'frecuency-zones'"
                        [layerDisplaySuffix]="'zonas de frecuencia'"
                        [isSearchDisabled]="isMapSelectionActive"
                        [(searchAddress)]="searchAddress"
                        (pointSelected)="onPointSelected($event)"
                        (isGeocoderReady)="onGeocoderReady($event)"
                        (dropdownVisibilityChange)="onDropdownVisibilityChange($event)">
                    </geocoder>
                    <button class="geocoder-btn" (click)="toggleMapSelection()" [disabled]="!isGeocoderReady" [ngClass]="{'active': isMapSelectionActive}" title="Seleccionar punto desde el mapa">
                        <mat-icon class="button-icon">location_searching</mat-icon>
                    </button>
                </div>

                <div class="button-group">
                    <button class="btn-reset" (click)="reset()" title="Reiniciar búsqueda">
                        <mat-icon class="button-icon">refresh</mat-icon>
                        <span>Reiniciar</span>
                    </button>
                    <button class="btn-search" [disabled]="!isGeocoderReady || isMapSelectionActive || searchAddress.trim().length === 0" (click)="search()" title="Buscar">
                        <mat-icon class="button-icon">search</mat-icon>
                        <span>Buscar</span>
                    </button>
                </div>
            </div>


            <div class="details-section" *ngIf="frequencyPoints.length > 0">
                <!-- <div class="divider"></div> -->

                <div class="location-header">
                    <span class="location-badge">Ubicación Seleccionada</span>
                    <h3 class="location-title">{{ frequencyPoints[0].nombre }}</h3>
                    <div class="location-subtitle">
                        <mat-icon class="button-icon">place</mat-icon>
                        <span>Zona {{ frequencyPoints[0].properties.Zone }}</span>
                    </div>
                </div>

                <div class="details-list">
                    <ng-container *ngFor="let item of frequencyPoints[0].properties | keyvalue">
                        <div class="detail-item" *ngIf="item.key !== 'Nombre' && item.key !=='Zone'">
                            <div class="detail-icon">
                                <img [src]="('frecuency' | frecuencyIcons:item.key:item.value) | findUrl" alt="">
                            </div>
                            <div class="detail-info">
                                <p class="detail-key">{{ item.key }}</p>
                                <p class="detail-value">{{ item.value }}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div *ngIf="!isLoading && frequencyPoints.length === 0 && searchAddress.length > 0">
                <p>No se encontraron ubicaciones cercanas.</p>
            </div>
        </div>

        <div class="panel-bottom" *ngIf="frequencyPoints.length > 0">
            <button class="btn-action-main" (click)="openPopUp()">
                <mat-icon class="button-icon">map</mat-icon>
                <span>Ver en Mapa</span>
            </button>
        </div>
    </div>
</div>
